import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierOtherEventsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierOtherEventsController.php
* @route '/api/dossier/update-other-events/{dossier}'
*/
const UpdateDossierOtherEventsController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierOtherEventsController.url(args, options),
    method: 'put',
})

UpdateDossierOtherEventsController.definition = {
    methods: ["put"],
    url: '/api/dossier/update-other-events/{dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierOtherEventsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierOtherEventsController.php
* @route '/api/dossier/update-other-events/{dossier}'
*/
UpdateDossierOtherEventsController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierOtherEventsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierOtherEventsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierOtherEventsController.php
* @route '/api/dossier/update-other-events/{dossier}'
*/
UpdateDossierOtherEventsController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierOtherEventsController.url(args, options),
    method: 'put',
})

export default UpdateDossierOtherEventsController